import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../utils/cn';

const labelVariants = cva('block font-medium', {
  variants: {
    variant: {
      default: 'text-sm text-text-secondary',
      inline: 'text-xs text-text-muted',
      section: 'text-sm text-text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement>, VariantProps<typeof labelVariants> {
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, variant, children, required, ...props }, ref) => {
    return (
      <label className={cn(labelVariants({ variant }), className)} ref={ref} {...props}>
        {children}
        {required && <span className="text-feedback-error ml-1">*</span>}
      </label>
    );
  },
);

Label.displayName = 'Label';
